import React, { useContext, useEffect, useState, useMemo } from 'react';
import {
    Modal,
    Table,
    Tag,
    Typography,
    Button,
    Card,
    Row,
    Col,
    Statistic,
    Input,
    Space,
    Avatar,
    Progress,
    Tooltip,
    Radio,
    message,
    DatePicker,
    Tabs,
    Timeline,
    Empty,
    Select,
    Popconfirm
} from 'antd';
import { ColumnsType, TableProps } from 'antd/es/table';
import {
    TeamOutlined,
    SearchOutlined,
    ReloadOutlined,
    UserOutlined,
    AreaChartOutlined,
    TrophyOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    LockOutlined,
    UnlockOutlined,
    AppstoreOutlined,
    BarsOutlined,
    EyeOutlined,
    ThunderboltOutlined,
    DesktopOutlined,
    HistoryOutlined,
    LeftOutlined,
    RightOutlined,
    ClockCircleOutlined,
    FileOutlined,
    PlayCircleOutlined,
    CodeOutlined,
    CopyOutlined,
    MinusCircleTwoTone,
    UserSwitchOutlined,
    BugOutlined,
    UndoOutlined,
    EyeInvisibleOutlined
} from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';
import { GetUsuariIdActivitatsAlumnes } from '../../../../dao/GetUsuariIdActivitatsAlumnes';
import { GetUsuariIdActivitatsId } from '../../../../dao/GetUsuariIdActivitatsId';
import { GetRankingsUsuariId } from '../../../../dao/jutge/GetRankingsUsuariId';
import { GetAlumneId } from '../../../../dao/GetAlumneId';
import { DefaultAulumneInfo } from '../../../../model/AlumneInfo';
import RevisioModal from '../../activitatsId/content/RevisioModal';
import UseWebSocketSubscription from '../../../UseWebSocketSubscription';
import { AuthContext } from '../../../../config/AuthContext';
import { getPenalitzacioPerIntent, aplicarPenalitzacio } from '../../disseny/engine/notaPenalitzacio';
import { GetJBbddProblemesId } from '../../../../dao/bbdd/GetJBbddProblemesId';
import { GetJBbddProblemesIdEnviament } from '../../../../dao/bbdd/GetJBbddProblemesIdEnviament';
import { GetBbddProblemaIdUsuariId } from '../../../../dao/bbdd/GetBbddProblemaIdUsuariId';
import { validateErDiagram } from '../../disseny/engine/ErValidator';
import { validateScriptRelational, parseScriptTextToData } from '../../disseny/engine/ScriptRelationalEngine';
import { validateRelationalDiagram } from '../../disseny/engine/RelationalValidator';

const { Text, Title } = Typography;

interface Props {
    visible?: boolean;
    onClose?: () => void;
    activitat: any;
    isPage?: boolean;
}

const ActivitatAlumnesBbddModal: React.FC<Props> = ({ visible = true, onClose, activitat, isPage = false }) => {
    const {
        isLoggedIn,
        userId,
        setLoggedIn,
        setUserId,
        setUser,
        setAlumneInfo,
        setUserPermisos
    } = useContext(AuthContext);

    const [loading, setLoading] = useState(false);
    const [loadingStats, setLoadingStats] = useState(false);
    const [reevaluating, setReevaluating] = useState(false);
    const [reevalProgress, setReevalProgress] = useState<{ done: number; total: number }>({ done: 0, total: 0 });
    const [impersonatingId, setImpersonatingId] = useState<string | number | null>(null);
    const [dades, setDades] = useState<any[]>([]);
    const [avatars, setAvatars] = useState<Record<string | number, string>>({});
    const [subData, setSubData] = useState<Record<string | number, any[]>>({});
    const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);
    const [searchText, setSearchText] = useState('');
    const [viewMode, setViewMode] = useState<'cards' | 'table'>('cards');

    // Estat de bloqueig per a examen/desafio (sincronitzat amb backend)
    const [lockedUsers, setLockedUsers] = useState<Record<string, boolean>>({});
    const [unlocking, setUnlocking] = useState<string | null>(null);

    // Estat d'accés a l'examen (jutge.examen_alumne): iniciat / botó ocultat
    const [startedExamUsers, setStartedExamUsers] = useState<Record<string, string>>({});
    const [examActionUser, setExamActionUser] = useState<string | null>(null);
    const [finishingExam, setFinishingExam] = useState(false);

    // Modal per revisar el codi enviat per l'alumne
    const [revisioModalVisible, setRevisioModalVisible] = useState(false);
    const [selectedProblema, setSelectedProblema] = useState<any>(null);
    const [selectedStudentId, setSelectedStudentId] = useState<string | number | undefined>(undefined);

    // Modal per veure l'historial de telemetria de l'alumne (com a jutge)
    const [telemetryModalVisible, setTelemetryModalVisible] = useState(false);
    const [telemetryStudent, setTelemetryStudent] = useState<any | null>(null);
    const [telemetryEvents, setTelemetryEvents] = useState<any[]>([]);
    const [telemetryClipboardEvents, setTelemetryClipboardEvents] = useState<any[]>([]);
    const [telemetryLockEvents, setTelemetryLockEvents] = useState<any[]>([]);
    const [activeTelemetryTabKey, setActiveTelemetryTabKey] = useState<'timeline' | 'clipboard' | 'locks'>('timeline');
    const [telemetryLoading, setTelemetryLoading] = useState(false);
    const [telemetryDate, setTelemetryDate] = useState<Dayjs>(dayjs());
    const [selectedFileFilter, setSelectedFileFilter] = useState<string | null>(null);

    const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost';

    const formatDuration = (seconds: number): string => {
        if (!seconds || seconds <= 0) return '0s';
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        if (h > 0) return `${h}h ${m}m ${s}s`;
        if (m > 0) return `${m}m ${s}s`;
        return `${s}s`;
    };

    const formatDateTime = (iso: string) => {
        if (!iso) return '';
        const dj = dayjs(iso);
        if (!dj.isValid()) return iso;
        return dj.format('HH:mm:ss');
    };

    const openTelemetryDetail = async (student: any) => {
        setTelemetryStudent(student);
        setTelemetryModalVisible(true);
        setSelectedFileFilter(null);
        setActiveTelemetryTabKey('timeline');
        setTelemetryDate(dayjs());
        setTelemetryEvents([]);
        setTelemetryClipboardEvents([]);
        setTelemetryLockEvents([]);
        setTelemetryLoading(true);
        try {
            const token = localStorage.getItem('authToken');
            const uid = student.id_usuari || student.numericId || student.id;
            const [res, clipRes, lockRes] = await Promise.all([
                fetch(`${baseUrl}:8061/telemetry/admin/student/${uid}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                }),
                fetch(`${baseUrl}:8061/telemetry/admin/student/${uid}/clipboard`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                }),
                fetch(`${baseUrl}:8061/telemetry/admin/student/${uid}/lock-events`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                })
            ]);
            if (res.ok) {
                const data = await res.json();
                setTelemetryEvents(Array.isArray(data) ? data : []);
            }
            if (clipRes.ok) {
                const clipData = await clipRes.json();
                setTelemetryClipboardEvents(Array.isArray(clipData) ? clipData : []);
            }
            if (lockRes.ok) {
                const lockData = await lockRes.json();
                setTelemetryLockEvents(Array.isArray(lockData) ? lockData : []);
            }
        } catch (e) {
            console.error("Error carregant telemetria:", e);
        } finally {
            setTelemetryLoading(false);
        }
    };

    const isTodaySelected = telemetryDate.isSame(dayjs(), 'day');

    const displayedTelemetryEvents = useMemo(() => {
        return telemetryEvents.filter(ev => {
            if (!ev.event_ts) return false;
            const d = dayjs(ev.event_ts);
            return d.isValid() && d.isSame(telemetryDate, 'day');
        });
    }, [telemetryEvents, telemetryDate]);

    const availableTelemetryFiles = useMemo(() => {
        const fileMap: Record<string, { count: number; edits: number; language?: string }> = {};
        displayedTelemetryEvents.forEach(ev => {
            const f = ev.file || '(Sense fitxer)';
            if (!fileMap[f]) fileMap[f] = { count: 0, edits: 0, language: ev.language };
            fileMap[f].count += 1;
            fileMap[f].edits += (ev.edits || 0);
            if (!fileMap[f].language && ev.language) fileMap[f].language = ev.language;
        });
        return fileMap;
    }, [displayedTelemetryEvents]);

    const eventsFilteredByFile = useMemo(() => {
        if (!selectedFileFilter) return displayedTelemetryEvents;
        return displayedTelemetryEvents.filter(ev => (ev.file || '(Sense fitxer)') === selectedFileFilter);
    }, [displayedTelemetryEvents, selectedFileFilter]);

    const groupedTelemetryItems = useMemo(() => {
        const getEvStatus = (ev: any): 'activo' | 'conectado' | 'desconectado' => {
            const isOnline = Number(ev.active) === 1 || Number(ev.focused) === 1;
            if (!isOnline) return 'desconectado';
            if ((ev.edits || 0) > 0 || (ev.runs || 0) > 0 || (ev.debugs || 0) > 0) return 'activo';
            return 'conectado';
        };

        const result: any[] = [];
        let i = 0;
        const events = eventsFilteredByFile;

        while (i < events.length) {
            const ev = events[i];
            const evStatus = getEvStatus(ev);
            const hasEditsOrExec = (ev.edits > 0) || ((ev.runs || 0) > 0) || ((ev.debugs || 0) > 0);

            if (hasEditsOrExec) {
                result.push({
                    isGroup: false,
                    representativeEvent: ev,
                    count: 1,
                    startTs: ev.event_ts,
                    endTs: ev.event_ts,
                    totalActiveSeconds: ev.active_seconds || 0,
                    eventStatus: evStatus,
                    file: ev.file,
                    files: ev.file ? [ev.file] : [],
                    language: ev.language,
                    project: ev.project
                });
                i++;
                continue;
            }

            const fileSet = new Set<string>();
            if (ev.file) fileSet.add(ev.file);
            let groupCount = 1;
            let totalActiveSecs = ev.active_seconds || 0;
            let lastEventTs = ev.event_ts;
            let j = i + 1;

            while (j < events.length) {
                const nextEv = events[j];
                const nextHasEdits = (nextEv.edits > 0) || ((nextEv.runs || 0) > 0) || ((nextEv.debugs || 0) > 0);
                const nextStatus = getEvStatus(nextEv);

                if (nextHasEdits || nextStatus !== evStatus) break;
                if (nextEv.file) fileSet.add(nextEv.file);
                groupCount++;
                totalActiveSecs += (nextEv.active_seconds || 0);
                lastEventTs = nextEv.event_ts;
                j++;
            }

            result.push({
                isGroup: groupCount > 1,
                representativeEvent: ev,
                count: groupCount,
                startTs: lastEventTs,
                endTs: ev.event_ts,
                totalActiveSeconds: totalActiveSecs,
                eventStatus: evStatus,
                file: ev.file,
                files: Array.from(fileSet),
                language: ev.language,
                project: ev.project
            });
            i = j;
        }

        return result;
    }, [eventsFilteredByFile]);

    const isExamActivitat = Number(activitat?.is_examen ?? activitat?.isExamen) === 1;
    const hasStartedExam = (student: any) => {
        const uid = String(student.numericId || student.id_usuari);
        return Object.prototype.hasOwnProperty.call(startedExamUsers, uid);
    };
    const startedExamAt = (student: any) => {
        const uid = String(student.numericId || student.id_usuari);
        return startedExamUsers[uid];
    };

    const fetchExamStudents = async () => {
        if (!activitat?.id) return;
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/${activitat.id}/students`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                const arr = Array.isArray(data) ? data : [];
                const map: Record<string, string> = {};
                arr.forEach((s: any) => { if (s && s.id !== undefined) map[String(s.id)] = s.started_at; });
                setStartedExamUsers(map);
            }
        } catch (e) { /* silenciós */ }
    };

    // Reinicia l'accés a l'examen (torna a mostrar el botó "Iniciar exàmen" a l'alumne).
    const resetExamStudent = async (student: any) => {
        const uid = String(student.numericId || student.id_usuari);
        setExamActionUser(uid);
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/${activitat.id}/reset/user/${uid}`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                message.success(`Accés a l'examen reiniciat per a ${student.usuari || uid}`);
                setStartedExamUsers(prev => {
                    const next = { ...prev };
                    delete next[uid];
                    return next;
                });
            } else {
                message.error("Error al reiniciar l'accés a l'examen");
            }
        } catch (e) {
            message.error("Error de connexió");
        } finally {
            setExamActionUser(null);
        }
    };

    // Acció inversa: marca l'alumne com que ja ha accedit (li OCULTA el botó "Iniciar exàmen").
    const markExamStudent = async (student: any) => {
        const uid = String(student.numericId || student.id_usuari);
        setExamActionUser(uid);
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/${activitat.id}/mark/user/${uid}`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                message.success(`Botó d'examen ocultat per a ${student.usuari || uid}`);
                setStartedExamUsers(prev => ({ ...prev, [uid]: new Date().toISOString() }));
            } else {
                message.error("Error al ocultar el botó d'examen");
            }
        } catch (e) {
            message.error("Error de connexió");
        } finally {
            setExamActionUser(null);
        }
    };

    const confirmResetExam = (student: any) => {
        Modal.confirm({
            title: `Reiniciar l'accés a l'examen?`,
            content: `${student.usuari || student.id_usuari} tornarà a veure el botó "Iniciar exàmen" i podrà tornar a entrar a l'examen.`,
            okText: 'Reiniciar',
            okButtonProps: { danger: true },
            cancelText: 'Cancel·lar',
            onOk: () => resetExamStudent(student)
        });
    };

    // "Acabar examen": oculta el botó a TOTS els alumnes que encara el veuen (no iniciats).
    const finishExamForAll = async (pendingIds: string[]) => {
        if (pendingIds.length === 0) {
            message.info("Tots els alumnes ja tenen el botó ocultat.");
            return;
        }
        setFinishingExam(true);
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/${activitat.id}/mark/all`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ ids: pendingIds })
            });
            if (res.ok) {
                message.success(`Examen acabat: botó ocultat per a ${pendingIds.length} alumne(s).`);
                setStartedExamUsers(prev => {
                    const next = { ...prev };
                    const now = new Date().toISOString();
                    pendingIds.forEach(id => { next[id] = now; });
                    return next;
                });
            } else {
                message.error("Error en acabar l'examen");
            }
        } catch (e) {
            message.error("Error de connexió");
        } finally {
            setFinishingExam(false);
        }
    };

    const confirmFinishExam = (pendingIds: string[]) => {
        Modal.confirm({
            title: 'Acabar l\'examen per a tothom?',
            content: `S'ocultarà el botó "Iniciar exàmen" a ${pendingIds.length} alumne(s) que encara el veuen. No podran (tornar a) entrar a l'examen tret que els reiniciïs individualment.`,
            okText: 'Acabar examen',
            okButtonProps: { danger: true },
            cancelText: 'Cancel·lar',
            onOk: () => finishExamForAll(pendingIds)
        });
    };

    useEffect(() => {
        if (visible && activitat) {
            fetchData();
            fetchLocks();
            fetchExamStudents();

            const interval = setInterval(() => {
                if (!document.hidden) {
                    fetchLocks();
                    fetchExamStudents();
                }
            }, 10000);
            return () => clearInterval(interval);
        } else {
            setDades([]);
            setSubData({});
            setExpandedRowKeys([]);
            setSearchText('');
            setStartedExamUsers({});
        }
    }, [visible, activitat]);

    // WebSocket per rebre canvis de bloqueig en temps real
    UseWebSocketSubscription(
        visible && isLoggedIn ? ['/topic/exam/locks'] : [],
        (topic: string, data: any) => {
            if (data && data.idUsuari !== undefined) {
                setLockedUsers(prev => ({ ...prev, [String(data.idUsuari)]: data.locked }));
            }
        }
    );

    // Consulta de bloquejos actius
    const fetchLocks = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/locks`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setLockedUsers(data || {});
            }
        } catch (e) { /* silenciós */ }
    };

    const isLocked = (student: any) => {
        const uid = String(student.numericId || student.id_usuari);
        return !!lockedUsers[uid];
    };

    const unlockStudent = async (student: any) => {
        const uid = String(student.numericId || student.id_usuari);
        setUnlocking(uid);
        try {
            const token = localStorage.getItem('authToken');
            const res = await fetch(`${baseUrl}:8061/jutge/exam/unlock`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ id_usuari: uid })
            });
            if (res.ok) {
                message.success(`IDE desbloquejat per a ${student.usuari || uid}`);
                setLockedUsers(prev => ({ ...prev, [uid]: false, [String(student.id_usuari)]: false }));
            } else {
                message.error("Error al desbloquejar l'IDE");
            }
        } catch (e) {
            message.error("Error de connexió");
        } finally {
            setUnlocking(null);
        }
    };

    // Acció d'impersonar un alumne
    const handleImpersonate = async (studentId: string | number) => {
        setImpersonatingId(studentId);
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(`${baseUrl}:8061/login/impersonate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ adminId: userId, targetId: String(studentId) })
            });

            if (response.ok) {
                const data = await response.json();
                const { token: newToken, permisos } = data;

                let alu = DefaultAulumneInfo;
                if (permisos && permisos.length > 0) {
                    const res = await GetAlumneId(permisos[0].id, newToken);
                    if (res) alu = res;
                }

                // Desar l'estat d'administrador original
                if (!localStorage.getItem('adminToken')) {
                    localStorage.setItem('adminToken', localStorage.getItem('authToken') || '');
                    localStorage.setItem('admin_userId', localStorage.getItem('userId') || '');
                    localStorage.setItem('admin_user', localStorage.getItem('user') || '');
                    localStorage.setItem('admin_userPermisos', localStorage.getItem('userPermisos') || '');
                    localStorage.setItem('admin_alumneInfo', localStorage.getItem('alumneInfo') || '');
                }

                localStorage.setItem('authToken', newToken);

                setLoggedIn(true);
                setUserId(String(permisos[0].id));
                setUser(permisos[0]);
                setUserPermisos(permisos);
                setAlumneInfo(alu);

                message.success('Impersonant usuari...');
                window.location.reload();
            } else {
                message.error("Error al impersonar l'alumne.");
            }
        } catch (e) {
            console.error("Error en impersonar:", e);
            message.error("Error de connexió al impersonar.");
        } finally {
            setImpersonatingId(null);
        }
    };

    async function fetchData() {
        setLoading(true);
        try {
            const [raw, rankData] = await Promise.all([
                GetUsuariIdActivitatsAlumnes(activitat.id_usuari || "0", activitat.id + ""),
                GetRankingsUsuariId(userId + "")
            ]);

            let studentList: any[] = Array.isArray(raw) ? raw : [];
            studentList.sort((a, b) => (a.usuari || '').localeCompare(b.usuari || ''));
            setDades(studentList);

            // Carregar avatars
            const map: Record<string, string> = {};
            if (rankData) {
                const ranking = Array.isArray(rankData) ? rankData : rankData.ranking || [];
                ranking.forEach((r: any) => {
                    const uid = r.id_usuari || r.id;
                    if (uid && r.avatar) map[String(uid)] = r.avatar;
                });
            }
            studentList.forEach(s => {
                if (s.id_usuari && s.avatar) {
                    map[String(s.id_usuari)] = s.avatar;
                }
            });
            setAvatars(prev => ({ ...prev, ...map }));

            // En segon pla carregar exercicis de cada alumne
            enrichMetrics(studentList);
        } catch (e) {
            console.error("Error carregant alumnes de l'activitat BBDD:", e);
            setDades([]);
        } finally {
            setLoading(false);
        }
    }

    async function enrichMetrics(studentList: any[]) {
        setLoadingStats(true);
        for (const st of studentList) {
            try {
                const exercicis = await GetUsuariIdActivitatsId(st.id_usuari + "", activitat.id + "");
                if (Array.isArray(exercicis)) {
                    setSubData(prev => ({ ...prev, [st.id_usuari]: exercicis }));
                    let totalBe = 0;
                    let totalIntents = 0;
                    let totalProg = 0;

                    exercicis.forEach((ex: any) => {
                        // Progrés global = MITJANA ARITMÈTICA de les notes de cada exercici (nota
                        // de l'últim enviament, ex.nota), igual que calcula el backend a
                        // get_activitats per a la taula d'Activitats/Exàmens. NO apliquem aquí la
                        // penalització dinàmica, perquè si no les dues vistes no coincideixen.
                        const notaEx = notaBaseExercici(ex);
                        totalProg += notaEx;
                        const intents = Number(ex.intents || 0);
                        totalIntents += intents;
                        if (notaEx >= 100) totalBe++;
                    });

                    const progresCalculat = exercicis.length > 0 ? (totalProg / exercicis.length) : 0;

                    setDades(prev => prev.map(item => {
                        if (item.id_usuari === st.id_usuari) {
                            return {
                                ...item,
                                intents: totalIntents > 0 ? totalIntents : item.intents,
                                be: totalBe > 0 ? totalBe : item.be,
                                malament: Math.max(0, totalIntents - totalBe),
                                progres: Number(Math.min(100, Math.max(0, progresCalculat)).toFixed(1))
                            };
                        }
                        return item;
                    }));
                }
            } catch (err) { }
        }
        setLoadingStats(false);
    }

    // Reevaluar TOT: per a cada alumne i cada exercici on hagi enviat ALGUNA COSA (mínim un
    // enviament amb contingut), es recalcula la nota base al client i es fa un NOU reenviament
    // avaluat. Els exercicis sense cap enviament no es toquen. No s'esborra res.
    const reevaluarCache = React.useRef<Map<string, { correccio: any; tipus: string; customConf: any }>>(new Map());

    const getProblemaInfo = async (idProblema: string) => {
        const key = String(idProblema);
        if (reevaluarCache.current.has(key)) return reevaluarCache.current.get(key)!;
        let correccio: any = null;
        let tipus = '';
        let customConf: any = null;
        try {
            const prob: any = await GetJBbddProblemesId(key);
            if (prob) {
                tipus = prob.tipus || '';
                if (prob.correccio) {
                    correccio = typeof prob.correccio === 'string'
                        ? (prob.correccio.trim().startsWith('{') ? JSON.parse(prob.correccio) : prob.correccio)
                        : prob.correccio;
                }
                if (prob.test_config) {
                    try { customConf = typeof prob.test_config === 'string' ? JSON.parse(prob.test_config) : prob.test_config; } catch (_) {}
                }
                if (!customConf && prob.checks) {
                    try {
                        let jsonPart = prob.checks;
                        const hashIdx = prob.checks.indexOf('#');
                        if (hashIdx !== -1 && prob.checks.slice(hashIdx + 1).trim().startsWith('{')) jsonPart = prob.checks.slice(hashIdx + 1).trim();
                        customConf = JSON.parse(jsonPart);
                    } catch (_) {}
                }
            }
        } catch (_) {}
        const info = { correccio, tipus, customConf };
        reevaluarCache.current.set(key, info);
        return info;
    };

    // Calcula la nota BASE i el feedback d'un enviament de disseny (sense penalització).
    const calcularResultatDisseny = (tipus: string, actual: string, correccio: any, customConf: any): { notaBase: number; feedbackJson: string } | undefined => {
        try {
            if (!correccio || !actual) return undefined;
            let res: any = null;
            if (tipus === 'ER') {
                const stuObj = typeof actual === 'string' ? JSON.parse(actual) : actual;
                const solParsed = typeof correccio === 'string' ? JSON.parse(correccio) : correccio;
                res = validateErDiagram(stuObj, solParsed, customConf, 0);
            } else if (tipus === 'Script') {
                const stuObj = (typeof actual === 'string' && actual.trim().startsWith('{')) ? JSON.parse(actual) : parseScriptTextToData(actual);
                const solParsed = (correccio && correccio.tables && Array.isArray(correccio.tables)) ? correccio : (typeof correccio === 'string' ? parseScriptTextToData(correccio) : correccio);
                res = validateScriptRelational(stuObj, solParsed, customConf, 0);
            } else if (tipus === 'Relacional') {
                const stuObj = typeof actual === 'string' ? JSON.parse(actual) : actual;
                const solParsed = typeof correccio === 'string' ? JSON.parse(correccio) : correccio;
                res = validateRelationalDiagram(stuObj, solParsed, customConf, 0);
            }
            if (res) {
                const notaBase = res.notaBase !== undefined ? res.notaBase : res.score;
                const feedbackJson = JSON.stringify({ notaBase, feedback: res.feedback || [], summary: res.summary || null, tipus });
                return { notaBase, feedbackJson };
            }
        } catch (_) {}
        return undefined;
    };

    const handleReevaluarTot = async () => {
        if (reevaluating) return;
        setReevaluating(true);
        let done = 0;
        let reenviats = 0;
        let saltats = 0;

        try {
            // Assegurar que tenim els exercicis de cada alumne carregats.
            const feines: Array<{ student: any; ex: any }> = [];
            for (const student of dades) {
                let exs = subData[student.id_usuari];
                if (!exs) {
                    try {
                        exs = await GetUsuariIdActivitatsId(student.id_usuari + "", activitat.id + "");
                        if (Array.isArray(exs)) setSubData(prev => ({ ...prev, [student.id_usuari]: exs }));
                    } catch (_) { exs = []; }
                }
                (exs || []).forEach((ex: any) => feines.push({ student, ex }));
            }

            setReevalProgress({ done: 0, total: feines.length });

            const effectivePractica = String(activitat.id);

            for (const { student, ex } of feines) {
                const idProblema = String(ex.id || ex.id_problema || '');
                const idUsuari = String(student.id_usuari);
                try {
                    // 1) Obtenir els enviaments reals de l'alumne per a aquest exercici.
                    const envs: any = await GetJBbddProblemesIdEnviament(idProblema, idUsuari, effectivePractica);
                    const realEnvs = Array.isArray(envs)
                        ? envs.filter((e: any) => !e.draft && e.errors !== 'DRAFT_GUARDAT' && e.actual && String(e.actual).trim() !== '')
                        : [];

                    // Si no ha enviat MAI res en aquest exercici, no reenviem.
                    if (realEnvs.length === 0) { saltats++; continue; }

                    // Darrer enviament (ordre descendent per id) com a resposta a reavaluar.
                    const darrer = realEnvs.reduce((a: any, b: any) => (Number(a.id) >= Number(b.id) ? a : b));
                    const actual = String(darrer.actual || '');
                    if (!actual.trim()) { saltats++; continue; }

                    // 2) Info del problema (tipus, solució, rúbrica).
                    const info = await getProblemaInfo(idProblema);
                    const tipus = info.tipus || ex.tipus || 'SQL';

                    // 3) Nota base: per a disseny la calculem al client; per a SQL/NoSQL la deixem
                    //    que l'avalui el backend (nota undefined).
                    let notaBase: number | undefined = undefined;
                    let feedbackJson: string | undefined = undefined;
                    if (tipus === 'ER' || tipus === 'Script' || tipus === 'Relacional') {
                        const resCalc = calcularResultatDisseny(tipus, actual, info.correccio, info.customConf);
                        if (resCalc) { notaBase = resCalc.notaBase; feedbackJson = resCalc.feedbackJson; }
                    }

                    const schema = (ex.esquema || ex.schema || (info as any).schema_name || '') as string;

                    // 4) Reenviament avaluat (amb el detall per desar a json_alumne).
                    await GetBbddProblemaIdUsuariId(idProblema, idUsuari, actual, tipus, schema, 'avaluar', notaBase, effectivePractica, feedbackJson);
                    reenviats++;
                } catch (_) {
                    // continuem amb la resta
                } finally {
                    done++;
                    setReevalProgress({ done, total: feines.length });
                }
            }

            message.success(`Reavaluació completada: ${reenviats} reenviaments, ${saltats} exercicis sense enviaments (omesos).`);
            // Refrescar mètriques per veure les noves notes.
            await enrichMetrics(dades);
        } catch (e: any) {
            message.error('Error durant la reavaluació: ' + (e?.message || e));
        } finally {
            setReevaluating(false);
            setReevalProgress({ done: 0, total: 0 });
        }
    };

    const handleExpand = async (expanded: boolean, record: any) => {
        if (expanded) {
            if (!subData[record.id_usuari]) {
                const exercicis = await GetUsuariIdActivitatsId(record.id_usuari + "", activitat.id + "");
                setSubData(prev => ({ ...prev, [record.id_usuari]: exercicis || [] }));
            }
            setExpandedRowKeys([record.id_usuari]);
        } else {
            setExpandedRowKeys(expandedRowKeys.filter(k => k !== record.id_usuari));
        }
    };

    function getAvatarSrc(img: string | undefined | null) {
        if (!img || img === "undefined" || img === "null") return undefined;
        if (img.startsWith("http") || img.startsWith("data:") || img.startsWith("/")) return img;
        if (img.startsWith("base64:")) img = img.split(":").pop()!;
        if (img.startsWith("/9j/")) return `data:image/jpeg;base64,${img}`;
        if (img.startsWith("iVB")) return `data:image/png;base64,${img}`;
        return `data:image/png;base64,${img}`;
    }

    const stringToColor = (str: string) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        let c = (hash & 0x00ffffff).toString(16).toUpperCase();
        return '#' + '00000'.substring(0, 6 - c.length) + c;
    };

    // Color gradual segons la nota (0-100):
    //  - 100  -> verd (perfecte)
    //  - 50-99 -> taronja/ambre, de "malament" (50) fins a "bé" (99)
    //  - <50  -> vermell, de "molt malament" (0) fins a "malament" (49)
    const lerpColor = (a: [number, number, number], b: [number, number, number], t: number): string => {
        const r = Math.round(a[0] + (b[0] - a[0]) * t);
        const g = Math.round(a[1] + (b[1] - a[1]) * t);
        const bl = Math.round(a[2] + (b[2] - a[2]) * t);
        return `rgb(${r}, ${g}, ${bl})`;
    };
    const notaColor = (valRaw: number): string => {
        const val = Math.max(0, Math.min(100, Number(valRaw) || 0));
        if (val >= 100) return '#389e0d';           // verd fosc (perfecte)
        if (val >= 50) {
            // 50 -> taronja fort (#d46b08), 99 -> groc-verd (#a0d911)
            const t = (val - 50) / 49;
            return lerpColor([212, 107, 8], [160, 217, 25], t);
        }
        // <50: 0 -> vermell molt fosc (#5c0011), 49 -> vermell clar (#ff4d4f)
        const t = val / 49;
        return lerpColor([92, 0, 17], [255, 77, 79], t);
    };

    // Nota efectiva d'un exercici per al resum: nota BASE desada amb la penalització per
    // intents fallits aplicada DINÀMICAMENT. Així el resum coincideix amb el modal.
    //
    // IMPORTANT: la nota base és el camp `ex.nota` (0-100), que és la nota real desada a
    // bbdd.respostes. NO fem servir `ex.progres`, perquè el procediment get_activitat_id
    // el calcula com a count(*) d'enviaments amb estat=2 (correctes), no com la nota: un
    // exercici amb nota 80 (estat=3, parcial) tindria progres=0 i sortiria 0/100.
    const notaBaseExercici = (ex: any): number => {
        if (ex?.nota !== null && ex?.nota !== undefined && !Number.isNaN(Number(ex.nota))) {
            return Math.max(0, Math.min(100, Number(ex.nota)));
        }
        // Fallback: si no hi ha `nota`, derivem de `progres` (fracció 0-1 d'exercicis correctes).
        return Math.max(0, Math.min(100, Number(ex?.progres || 0) * 100));
    };

    const notaEfectivaExercici = (ex: any): number => {
        const base = notaBaseExercici(ex);
        const ppi = getPenalitzacioPerIntent(ex?.test_config || ex?.checks);
        if (ppi <= 0) return base;
        const intents = Number(ex?.intents || 0);
        const complet = base >= 100;
        // Intents fallits = intents previs sense comptar l'intent correcte final (aproximació
        // quan no tenim el detall d'enviaments per exercici en el resum).
        const intentsFallits = complet ? Math.max(0, intents - 1) : intents;
        return aplicarPenalitzacio(base, intentsFallits, ppi).notaFinal;
    };

    const globalStats = useMemo(() => {
        if (!dades || dades.length === 0) {
            return { avgProgress: 0, totalBe: 0, totalMalament: 0, totalIntents: 0, passedCount: 0 };
        }
        let totalProg = 0;
        let totalBe = 0;
        let totalMalament = 0;
        let totalIntents = 0;
        let passedCount = 0;

        dades.forEach(s => {
            const p = Number(s.progres) || 0;
            totalProg += p;
            totalBe += (s.be || 0);
            totalMalament += (s.malament || 0);
            totalIntents += (s.intents || 0);
            if (p >= 50) passedCount++;
        });

        const avg = dades.length > 0 ? totalProg / dades.length : 0;
        return {
            avgProgress: Number(avg.toFixed(1)),
            totalBe,
            totalMalament,
            totalIntents,
            passedCount
        };
    }, [dades]);

    const filteredDades = useMemo(() => {
        if (!searchText.trim()) return dades;
        const q = searchText.toLowerCase();
        return dades.filter(s =>
            (s.usuari && s.usuari.toLowerCase().includes(q)) ||
            String(s.id_usuari).includes(q)
        );
    }, [dades, searchText]);

    const columns: ColumnsType<any> = [
        {
            key: 'usuari',
            title: 'Alumne',
            dataIndex: 'usuari',
            sorter: (a, b) => (a.usuari || '').localeCompare(b.usuari || ''),
            render: (nom, record) => {
                const avatarImg = avatars[record.id_usuari];
                const avatarSrc = getAvatarSrc(avatarImg);
                const initials = (nom || 'U').substring(0, 2).toUpperCase();
                const avatarBg = stringToColor(nom || 'User');
                const locked = isLocked(record);

                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        {avatarSrc ? (
                            <Avatar src={avatarSrc} size={40} style={{ border: locked ? '2px solid #ff4d4f' : '2px solid #e8e8e8' }} />
                        ) : (
                            <Avatar size={40} style={{ backgroundColor: avatarBg, fontWeight: 'bold', border: locked ? '2px solid #ff4d4f' : 'none' }}>
                                {initials}
                            </Avatar>
                        )}
                        <div>
                            <div style={{ fontWeight: 600, fontSize: 13, color: '#1f1f1f', display: 'flex', alignItems: 'center', gap: 6 }}>
                                <span>{nom}</span>
                                {isExamActivitat && (
                                    hasStartedExam(record) ? (
                                        <Tag color="volcano" icon={<PlayCircleOutlined />} style={{ fontSize: 10, padding: '0 4px', margin: 0 }}>
                                            Examen iniciat
                                        </Tag>
                                    ) : (
                                        <Tag color="default" style={{ fontSize: 10, padding: '0 4px', margin: 0 }}>
                                            Pot iniciar
                                        </Tag>
                                    )
                                )}
                                {locked && (
                                    <Tag color="red" icon={<LockOutlined />} style={{ fontSize: 10, padding: '0 4px', margin: 0 }}>
                                        Bloquejat
                                    </Tag>
                                )}
                            </div>
                            <Tag style={{ fontSize: 10, padding: '0 6px', margin: 0, borderRadius: 6, background: '#f5f5f5', border: '1px solid #d9d9d9', color: '#666' }}>
                                ID: #{record.id_usuari}
                            </Tag>
                        </div>
                    </div>
                );
            }
        },
        {
            key: 'intents',
            title: 'Intents',
            dataIndex: 'intents',
            align: 'center',
            sorter: (a, b) => (a.intents || 0) - (b.intents || 0),
            render: (val) => (
                <Tag color="default" style={{ fontWeight: 600, borderRadius: 8, padding: '2px 8px' }}>
                    {val || 0} enviaments
                </Tag>
            )
        },
        {
            key: 'stats',
            title: 'Tests Stats',
            align: 'center',
            render: (_, record) => (
                <Space size={8}>
                    <Tooltip title="Tests Superats Correctament">
                        <Tag
                            color="success"
                            icon={<CheckCircleOutlined />}
                            style={{ borderRadius: 8, padding: '2px 8px', fontWeight: 600, fontSize: 12 }}
                        >
                            {record.be || 0}
                        </Tag>
                    </Tooltip>
                    <Tooltip title="Tests amb Errors">
                        <Tag
                            color="error"
                            icon={<CloseCircleOutlined />}
                            style={{ borderRadius: 8, padding: '2px 8px', fontWeight: 600, fontSize: 12 }}
                        >
                            {record.malament || 0}
                        </Tag>
                    </Tooltip>
                </Space>
            )
        },
        {
            key: 'progres',
            title: 'Progrés / Assoliment',
            dataIndex: 'progres',
            align: 'left',
            sorter: (a, b) => (a.progres || 0) - (b.progres || 0),
            render: (nota) => {
                const val = Number(nota) || 0;
                const stroke = notaColor(val);

                return (
                    <div style={{ maxWidth: 220 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}>
                            <span style={{ fontWeight: 700, fontSize: 12, color: stroke }}>
                                {val.toFixed(1)}%
                            </span>
                        </div>
                        <Progress
                            percent={val}
                            size="small"
                            strokeColor={stroke}
                            showInfo={false}
                            style={{ margin: 0 }}
                        />
                    </div>
                );
            }
        },
        {
            key: 'actions',
            title: 'Accions',
            align: 'center',
            width: 140,
            render: (_, record) => {
                const isExpanded = expandedRowKeys.includes(record.id_usuari);
                const locked = isLocked(record);
                return (
                    <Space size={6}>
                        <Tooltip title="Veure historial de telemetria i activitat IDE de l'alumne">
                            <Button
                                shape="circle"
                                size="small"
                                style={{ color: '#1890ff', borderColor: '#91d5ff' }}
                                icon={<HistoryOutlined />}
                                onClick={() => openTelemetryDetail(record)}
                            />
                        </Tooltip>
                        {locked && (
                            <Tooltip title="Desbloquejar IDE de l'alumne">
                                <Button
                                    danger
                                    size="small"
                                    icon={<UnlockOutlined />}
                                    loading={unlocking === String(record.id_usuari)}
                                    onClick={() => unlockStudent(record)}
                                >
                                    Desbloquejar
                                </Button>
                            </Tooltip>
                        )}
                        <Tooltip title="Impersonar aquest alumne">
                            <Button
                                shape="circle"
                                size="small"
                                style={{ color: '#722ed1', borderColor: '#d3adf7' }}
                                icon={<UserSwitchOutlined />}
                                loading={impersonatingId === record.id_usuari}
                                onClick={() => handleImpersonate(record.id_usuari)}
                            />
                        </Tooltip>
                        {/* Accions d'examen a la taula */}
                        {isExamActivitat && (
                            hasStartedExam(record) ? (
                                <Tooltip title="Reiniciar l'accés a l'examen (tornar a mostrar el botó a l'alumne)">
                                    <Button
                                        shape="circle"
                                        size="small"
                                        loading={examActionUser === String(record.numericId || record.id_usuari)}
                                        style={{ color: '#fa541c', borderColor: '#ffbb96' }}
                                        icon={<UndoOutlined />}
                                        onClick={() => confirmResetExam(record)}
                                    />
                                </Tooltip>
                            ) : (
                                <Tooltip title="Ocultar el botó d'examen a l'alumne">
                                    <Button
                                        shape="circle"
                                        size="small"
                                        loading={examActionUser === String(record.numericId || record.id_usuari)}
                                        style={{ color: '#8c8c8c', borderColor: '#d9d9d9' }}
                                        icon={<EyeInvisibleOutlined />}
                                        onClick={() => markExamStudent(record)}
                                    />
                                </Tooltip>
                            )
                        )}
                        <Tooltip title={isExpanded ? "Plegar exercicis" : "Veure exercicis de l'alumne"}>
                            <Button
                                type={isExpanded ? "primary" : "default"}
                                shape="circle"
                                size="small"
                                icon={<EyeOutlined />}
                                onClick={() => handleExpand(!isExpanded, record)}
                            />
                        </Tooltip>
                    </Space>
                );
            }
        }
    ];

    const tableProps: TableProps<any> = { loading };
    const lockedCount = dades.filter(s => isLocked(s)).length;

    const mainContent = (
        <div style={isPage ? { padding: '24px 0' } : {}}>
            {/* Header Toolbar */}
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                    {loadingStats
                        ? "Sincronitzant mètriques detallades d'exercicis en segon pla..."
                        : "Avaluació en temps real, targetes d'alumnes i revisió de codi SQL."}
                </Text>
                <Space size={12}>
                    <Radio.Group
                        value={viewMode}
                        onChange={(e) => setViewMode(e.target.value)}
                        buttonStyle="solid"
                        size="small"
                    >
                        <Radio.Button value="cards">
                            <AppstoreOutlined style={{ marginRight: 4 }} /> Targetes
                        </Radio.Button>
                        <Radio.Button value="table">
                            <BarsOutlined style={{ marginRight: 4 }} /> Taula
                        </Radio.Button>
                    </Radio.Group>

                    <Input
                        placeholder="Cerca alumne o ID..."
                        prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                        allowClear
                        style={{ width: 200, borderRadius: 8 }}
                    />
                    <Button
                        type="primary"
                        icon={<ReloadOutlined />}
                        onClick={() => { fetchData(); fetchLocks(); fetchExamStudents(); }}
                        loading={loading || loadingStats}
                        style={{
                            background: '#1890ff',
                            borderColor: '#1890ff',
                            borderRadius: 8,
                            fontWeight: 500
                        }}
                    >
                        Refrescar
                    </Button>

                    <Popconfirm
                        title="Reavaluar tots els enviaments?"
                        description={
                            <div style={{ maxWidth: 320 }}>
                                Es farà un nou reenviament avaluat per a cada exercici on l'alumne hagi
                                enviat alguna cosa (els exercicis sense cap enviament no es toquen).
                                Això genera noves entrades (pot aplicar penalització per intents). No s'esborra res.
                            </div>
                        }
                        okText="Sí, reavaluar tot"
                        cancelText="Cancel·lar"
                        okButtonProps={{ loading: reevaluating }}
                        onConfirm={handleReevaluarTot}
                    >
                        <Button
                            icon={<ThunderboltOutlined />}
                            loading={reevaluating}
                            style={{ borderRadius: 8, fontWeight: 500, background: '#722ed1', borderColor: '#722ed1', color: '#fff' }}
                        >
                            {reevaluating
                                ? `Reavaluant… ${reevalProgress.done}/${reevalProgress.total}`
                                : 'Reavaluar tot'}
                        </Button>
                    </Popconfirm>

                    {isExamActivitat && (() => {
                        const pendingIds = dades
                            .filter((s: any) => !hasStartedExam(s))
                            .map((s: any) => String(s.numericId || s.id_usuari));
                        return (
                            <Tooltip title={pendingIds.length > 0
                                ? `Ocultar el botó "Iniciar exàmen" a ${pendingIds.length} alumne(s) que encara el veuen`
                                : 'Tots els alumnes ja tenen el botó ocultat'}>
                                <Button
                                    danger
                                    icon={<EyeInvisibleOutlined />}
                                    loading={finishingExam}
                                    disabled={pendingIds.length === 0}
                                    onClick={() => confirmFinishExam(pendingIds)}
                                    style={{ borderRadius: 8, fontWeight: 500 }}
                                >
                                    Acabar examen{pendingIds.length > 0 ? ` (${pendingIds.length})` : ''}
                                </Button>
                            </Tooltip>
                        );
                    })()}
                </Space>
            </div>

            {/* Targetes de resum superior */}
            <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.03)' }} bodyStyle={{ padding: '12px 16px' }}>
                        <Statistic
                            title={<span style={{ color: '#8c8c8c', fontSize: 12 }}>Alumnes</span>}
                            value={dades.length}
                            prefix={<UserOutlined style={{ color: '#1890ff', marginRight: 6 }} />}
                            valueStyle={{ fontWeight: 700, fontSize: 22 }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.03)' }} bodyStyle={{ padding: '12px 16px' }}>
                        <Statistic
                            title={<span style={{ color: '#8c8c8c', fontSize: 12 }}>Progrés Mitjà</span>}
                            value={globalStats.avgProgress}
                            precision={1}
                            suffix="%"
                            prefix={<AreaChartOutlined style={{ color: notaColor(globalStats.avgProgress), marginRight: 6 }} />}
                            valueStyle={{ color: notaColor(globalStats.avgProgress), fontWeight: 700, fontSize: 22 }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.03)' }} bodyStyle={{ padding: '12px 16px' }}>
                        <Statistic
                            title={<span style={{ color: '#8c8c8c', fontSize: 12 }}>Aprovats (≥50%)</span>}
                            value={globalStats.passedCount}
                            suffix={<span style={{ fontSize: 12, color: '#8c8c8c' }}>/ {dades.length}</span>}
                            prefix={<TrophyOutlined style={{ color: '#faad14', marginRight: 6 }} />}
                            valueStyle={{ color: '#52c41a', fontWeight: 700, fontSize: 22 }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card bordered={false} style={{ borderRadius: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.03)' }} bodyStyle={{ padding: '12px 16px' }}>
                        <Statistic
                            title={<span style={{ color: '#8c8c8c', fontSize: 12 }}>Tests Superats</span>}
                            value={globalStats.totalBe}
                            suffix={<span style={{ fontSize: 12, color: '#ff4d4f' }}> / {globalStats.totalMalament} ✖</span>}
                            prefix={<CheckCircleOutlined style={{ color: '#52c41a', marginRight: 6 }} />}
                            valueStyle={{ color: '#1890ff', fontWeight: 700, fontSize: 22 }}
                        />
                    </Card>
                </Col>
            </Row>

            {/* Targeta d'IDEs Bloquejats (si n'hi ha en mode examen) */}
            {lockedCount > 0 && (
                <Card
                    bordered={false}
                    style={{
                        borderRadius: 10,
                        marginBottom: 16,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.03)',
                        background: '#fff1f0',
                        border: '1px solid #ffccc7'
                    }}
                    bodyStyle={{ padding: '10px 16px' }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <LockOutlined style={{ color: '#cf1322', fontSize: 18 }} />
                            <Text strong style={{ color: '#cf1322' }}>
                                {lockedCount} alumne(s) amb l'IDE d'examen bloquejat per pèrdua de focus o infracció
                            </Text>
                        </div>
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                            {dades.filter(s => isLocked(s)).map(s => (
                                <Button
                                    key={s.id_usuari}
                                    size="small"
                                    danger
                                    icon={<UnlockOutlined />}
                                    loading={unlocking === String(s.numericId || s.id_usuari)}
                                    onClick={() => unlockStudent(s)}
                                >
                                    Desbloquejar {s.usuari}
                                </Button>
                            ))}
                        </div>
                    </div>
                </Card>
            )}

            {/* Vista de Targetes d'Alumnes (estil Jutge ActivitatsIdEstadistiques) */}
            {viewMode === 'cards' ? (
                <div style={{ maxHeight: '55vh', overflowY: 'auto', paddingRight: 4 }}>
                    <Row gutter={[12, 12]}>
                        {filteredDades.map(student => {
                            const name = student.usuari || 'Anònim';
                            const initials = name.substring(0, 2).toUpperCase();
                            const avatarColor = stringToColor(name);
                            const studentExercises = subData[student.id_usuari] || [];
                            const locked = isLocked(student);

                            let displayName = name;
                            const parts = name.trim().split(/\s+/);
                            if (parts.length > 1 && name.length > 12) {
                                displayName = `${parts[0]} ${parts[1].substring(0, 1).toUpperCase()}.`;
                            }

                            const cardBorderShadow = locked
                                ? '0 0 0 2px #ff4d4f'
                                : (Number(student.progres) >= 50
                                    ? '0 0 0 1px #d9d9d9, 0 2px 6px rgba(0,0,0,0.04)'
                                    : '0 0 0 1px #ffccc7, 0 2px 6px rgba(0,0,0,0.04)');

                            return (
                                <Col xs={24} sm={12} md={8} lg={6} xl={4} key={student.id_usuari}>
                                    <Card
                                        hoverable
                                        bordered={false}
                                        style={{
                                            borderRadius: 12,
                                            boxShadow: cardBorderShadow,
                                            transition: 'transform 0.2s, box-shadow 0.2s',
                                            cursor: 'default',
                                            background: '#fff'
                                        }}
                                        bodyStyle={{ padding: 14 }}
                                    >
                                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                                            {avatars[student.id_usuari] ? (
                                                <div style={{
                                                    width: 46,
                                                    height: 46,
                                                    borderRadius: '50%',
                                                    overflow: 'hidden',
                                                    border: locked ? '2px solid #ff4d4f' : '1px solid #f0f0f0',
                                                    flexShrink: 0
                                                }}>
                                                    <img
                                                        src={getAvatarSrc(avatars[student.id_usuari])}
                                                        alt="avatar"
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                                                    />
                                                </div>
                                            ) : (
                                                <Avatar
                                                    size={46}
                                                    style={{
                                                        backgroundColor: avatarColor,
                                                        verticalAlign: 'middle',
                                                        border: locked ? '2px solid #ff4d4f' : '1px solid #f0f0f0',
                                                        flexShrink: 0,
                                                        fontWeight: 700,
                                                        fontSize: 16
                                                    }}
                                                >
                                                    {initials}
                                                </Avatar>
                                            )}

                                            <div style={{ marginLeft: 10, flexGrow: 1, minWidth: 0 }}>
                                                <Text
                                                    strong
                                                    style={{
                                                        display: 'block',
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        fontSize: 14,
                                                        lineHeight: 1.25,
                                                        marginBottom: 4
                                                    }}
                                                    title={name}
                                                >
                                                    {displayName}
                                                </Text>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 4, flexWrap: 'wrap' }}>
                                                    <Tag
                                                        color={notaColor(Number(student.progres))}
                                                        style={{ margin: 0, fontSize: 11, borderRadius: 6, padding: '0 6px', fontWeight: 600, color: '#fff', border: 'none' }}
                                                    >
                                                        {Number(student.progres || 0).toFixed(1)}%
                                                    </Tag>

                                                    {/* Estat d'accés a l'examen */}
                                                    {isExamActivitat && (
                                                        hasStartedExam(student) ? (
                                                            <Tooltip title={`L'alumne ja ha accedit a l'examen${startedExamAt(student) ? ` (${dayjs(startedExamAt(student)).format('DD/MM HH:mm')})` : ''}. No veu el botó "Iniciar exàmen".`}>
                                                                <Tag
                                                                    color="volcano"
                                                                    icon={<PlayCircleOutlined />}
                                                                    style={{ margin: 0, fontSize: 10, borderRadius: 6, padding: '0 4px' }}
                                                                >
                                                                    Examen iniciat
                                                                </Tag>
                                                            </Tooltip>
                                                        ) : (
                                                            <Tooltip title={`L'alumne encara pot iniciar l'examen (veu el botó "Iniciar exàmen").`}>
                                                                <Tag
                                                                    color="default"
                                                                    style={{ margin: 0, fontSize: 10, borderRadius: 6, padding: '0 4px' }}
                                                                >
                                                                    Pot iniciar
                                                                </Tag>
                                                            </Tooltip>
                                                        )
                                                    )}

                                                    {locked && (
                                                        <Tooltip title="IDE bloquejat. Clica per desbloquejar">
                                                            <Tag
                                                                color="red"
                                                                icon={<UnlockOutlined />}
                                                                onClick={() => unlockStudent(student)}
                                                                style={{ margin: 0, fontSize: 10, borderRadius: 6, padding: '0 4px', cursor: 'pointer' }}
                                                            >
                                                                Desbloquejar
                                                            </Tag>
                                                        </Tooltip>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Colored exercise squares (Com a ActivitatsIdEstadistiques de Jutge) */}
                                        <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginTop: 10, minHeight: 24 }}>
                                            {studentExercises.length > 0 ? studentExercises.map((ex: any, idx: number) => {
                                                const notaEx = notaEfectivaExercici(ex); // nota base desada − penalització dinàmica
                                                const hasAttempts = Number(ex.intents || 0) > 0;
                                                // Sense intents -> gris. Amb intents -> color gradual segons la nota.
                                                const color = hasAttempts ? notaColor(notaEx) : '#f0f0f0';
                                                const borderColor = hasAttempts ? notaColor(notaEx) : '#d9d9d9';

                                                return (
                                                    <Tooltip
                                                        key={idx}
                                                        title={`${ex.prac || ex.nom || `Exercici ${ex.id}`} · Nota: ${Math.round(notaEx)}/100 (Intents: ${ex.intents || 0}) · Clica per veure codi SQL`}
                                                    >
                                                        <div
                                                            onClick={() => {
                                                                setSelectedProblema(ex);
                                                                setSelectedStudentId(student.id_usuari);
                                                                setRevisioModalVisible(true);
                                                            }}
                                                            style={{
                                                                width: 26,
                                                                height: 19,
                                                                borderRadius: 4,
                                                                backgroundColor: color,
                                                                border: `1px solid ${borderColor}`,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: '9px',
                                                                fontWeight: 'bold',
                                                                color: hasAttempts ? '#fff' : '#595959',
                                                                cursor: 'pointer',
                                                                transition: 'transform 0.15s'
                                                            }}
                                                            onMouseEnter={(e: any) => e.currentTarget.style.transform = 'scale(1.15)'}
                                                            onMouseLeave={(e: any) => e.currentTarget.style.transform = 'scale(1)'}
                                                        >
                                                            {idx + 1}
                                                        </div>
                                                    </Tooltip>
                                                );
                                            }) : (
                                                <Text type="secondary" style={{ fontSize: 11, width: '100%', textAlign: 'center' }}>Sense exercicis</Text>
                                            )}
                                        </div>

                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10, paddingTop: 6, borderTop: '1px solid #f5f5f5' }}>
                                            <span style={{ fontSize: 11, color: '#8c8c8c' }}>
                                                {student.be || 0} correctes
                                            </span>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                                {/* Botó Impersonar Alumne */}
                                                <Tooltip title="Impersonar aquest alumne">
                                                    <Button
                                                        size="small"
                                                        type="text"
                                                        icon={<UserSwitchOutlined style={{ color: '#1890ff', fontSize: 13 }} />}
                                                        loading={impersonatingId === student.id_usuari}
                                                        style={{ padding: '0 4px', height: '22px', minWidth: '22px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleImpersonate(student.id_usuari);
                                                        }}
                                                    />
                                                </Tooltip>

                                                <Tooltip title="Veure historial de telemetria de l'alumne">
                                                    <Button
                                                        type="text"
                                                        size="small"
                                                        style={{ padding: '0 4px', height: '22px', minWidth: '22px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                        icon={<HistoryOutlined style={{ color: '#8c8c8c', fontSize: 13 }} />}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            openTelemetryDetail(student);
                                                        }}
                                                    />
                                                </Tooltip>

                                                {/* Accions d'examen: només si l'activitat és un examen */}
                                                {isExamActivitat && (
                                                    hasStartedExam(student) ? (
                                                        <Tooltip title="Reiniciar l'accés a l'examen (tornar a mostrar el botó a l'alumne)">
                                                            <Button
                                                                type="text"
                                                                size="small"
                                                                loading={examActionUser === String(student.numericId || student.id_usuari)}
                                                                style={{ padding: '0 4px', height: '22px', minWidth: '22px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                                icon={<UndoOutlined style={{ color: '#fa541c', fontSize: 13 }} />}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    confirmResetExam(student);
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    ) : (
                                                        <Tooltip title="Ocultar el botó d'examen a l'alumne (marcar com a ja accedit)">
                                                            <Button
                                                                type="text"
                                                                size="small"
                                                                loading={examActionUser === String(student.numericId || student.id_usuari)}
                                                                style={{ padding: '0 4px', height: '22px', minWidth: '22px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                                icon={<EyeInvisibleOutlined style={{ color: '#8c8c8c', fontSize: 13 }} />}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    markExamStudent(student);
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    )
                                                )}

                                                <Tag style={{
                                                    margin: 0,
                                                    fontSize: 9,
                                                    lineHeight: '14px',
                                                    padding: '0 4px',
                                                    borderRadius: 4,
                                                    color: '#bfbfbf',
                                                    borderColor: '#f0f0f0',
                                                    backgroundColor: '#fafafa'
                                                }}>
                                                    #{student.id_usuari || student.numericId || student.id}
                                                </Tag>
                                            </div>
                                        </div>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                </div>
            ) : (
                /* Taula detallada amb expandable row */
                <Card
                    bordered={false}
                    bodyStyle={{ padding: 0 }}
                    style={{
                        borderRadius: 12,
                        overflow: 'hidden',
                        boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
                        background: '#ffffff'
                    }}
                >
                    <Table
                        size="small"
                        bordered={false}
                        {...tableProps}
                        pagination={{
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50'],
                            defaultPageSize: 10,
                            style: { padding: '10px 16px', margin: 0 }
                        }}
                        columns={columns}
                        dataSource={filteredDades}
                        rowKey="id_usuari"
                        expandable={{
                            expandedRowRender: (record) => {
                                const studentExercises = subData[record.id_usuari] || [];
                                return (
                                    <div style={{
                                        padding: "14px 20px",
                                        background: '#fafbfc',
                                        borderTop: '1px solid #f0f0f0',
                                        borderBottom: '1px solid #f0f0f0'
                                    }}>
                                        <div style={{ marginBottom: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <Text strong style={{ fontSize: 13, color: '#595959' }}>
                                                Exercicis SQL de l'estudiant:
                                            </Text>
                                            <Tag color="blue">{record.usuari}</Tag>
                                            <span style={{ fontSize: 11, color: '#888' }}>
                                                (Fes clic a qualsevol exercici per inspeccionar el codi enviat)
                                            </span>
                                        </div>

                                        {studentExercises.length === 0 ? (
                                            <div style={{ color: '#888', fontStyle: 'italic', fontSize: 12 }}>
                                                Carregant exercicis o l'alumne encara no ha iniciat cap exercici...
                                            </div>
                                        ) : (
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                                {studentExercises.map((ex: any, idx: number) => {
                                                    const notaEx = notaEfectivaExercici(ex); // nota base desada − penalització dinàmica
                                                    const isCompleted = notaEx >= 100;
                                                    const hasAttempts = Number(ex.intents || 0) > 0;
                                                    const origin = ex.origen || 'normal';

                                                    // Sense intents -> gris. Amb intents -> color gradual segons la nota.
                                                    const btnColor = hasAttempts ? notaColor(notaEx) : '#d9d9d9';

                                                    return (
                                                        <Tooltip
                                                            key={ex.id}
                                                            title={
                                                                <div>
                                                                    <div><strong>{ex.prac || ex.nom || `Exercici ${ex.id}`}</strong></div>
                                                                    <div>Nota: {Math.round(notaEx)}/100</div>
                                                                    <div>Estat: {isCompleted ? 'Completat' : hasAttempts ? 'No superat' : 'Sense intents'}</div>
                                                                    <div>Intents: {ex.intents || 0}</div>
                                                                    {ex.origen && <div>Origen: <Tag color="blue">{ex.origen}</Tag></div>}
                                                                </div>
                                                            }
                                                        >
                                                            <Button
                                                                size="small"
                                                                style={{
                                                                    backgroundColor: btnColor,
                                                                    borderColor: btnColor,
                                                                    color: isCompleted || hasAttempts ? '#fff' : '#555',
                                                                    fontWeight: 600,
                                                                    fontSize: 11,
                                                                    borderRadius: 6,
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    gap: 4
                                                                }}
                                                                onClick={() => {
                                                                    setSelectedProblema(ex);
                                                                    setSelectedStudentId(record.id_usuari);
                                                                    setRevisioModalVisible(true);
                                                                }}
                                                            >
                                                                <span>#{idx + 1}</span>
                                                                {origin === 'desafio' && <span>⚡</span>}
                                                                {origin === 'joc' && <span>🎮</span>}
                                                                {isCompleted ? <CheckCircleOutlined /> : (hasAttempts ? <CloseCircleOutlined /> : null)}
                                                            </Button>
                                                        </Tooltip>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                );
                            },
                            expandedRowKeys,
                            onExpand: handleExpand,
                        }}
                    />
                </Card>
            )}
        </div>
    );

    const extraModals = (
        <>
            {/* Modal de revisió del codi enviat per l'alumne */}
            {revisioModalVisible && selectedProblema && (
                <RevisioModal
                    element={selectedProblema}
                    id_alumne={selectedStudentId}
                    visible={revisioModalVisible}
                    onClose={() => {
                        setRevisioModalVisible(false);
                        setSelectedProblema(null);
                        setSelectedStudentId(undefined);
                    }}
                />
            )}

            {/* Modal d'historial de telemetria de l'alumne (com a Jutge) */}
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <HistoryOutlined style={{ color: '#1890ff', fontSize: 20 }} />
                        <span>
                            Historial IDE: {telemetryStudent?.nom ? `${telemetryStudent.nom} ${telemetryStudent.cognoms || ''}` : telemetryStudent?.usuari}
                        </span>
                    </div>
                }
                open={telemetryModalVisible}
                onCancel={() => {
                    setTelemetryModalVisible(false);
                    setTelemetryStudent(null);
                }}
                footer={[
                    <Button key="close" type="primary" onClick={() => {
                        setTelemetryModalVisible(false);
                        setTelemetryStudent(null);
                    }}>
                        Tancar
                    </Button>
                ]}
                width={780}
            >
                {telemetryStudent && (
                    <>
                        {/* Selector de dia i navegació */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8, background: '#fafafa', padding: '10px 14px', borderRadius: 8, border: '1px solid #f0f0f0' }}>
                            <Space size="small">
                                <Button
                                    icon={<LeftOutlined />}
                                    onClick={() => setTelemetryDate(d => d.subtract(1, 'day'))}
                                    title="Dia anterior"
                                />
                                <DatePicker
                                    value={telemetryDate}
                                    onChange={d => d && setTelemetryDate(d)}
                                    allowClear={false}
                                    format="DD/MM/YYYY"
                                    style={{ width: 130 }}
                                />
                                <Button
                                    icon={<RightOutlined />}
                                    onClick={() => setTelemetryDate(d => d.add(1, 'day'))}
                                    disabled={isTodaySelected}
                                    title="Dia següent"
                                />
                                {!isTodaySelected && (
                                    <Button
                                        type="dashed"
                                        size="small"
                                        onClick={() => setTelemetryDate(dayjs())}
                                    >
                                        Avui
                                    </Button>
                                )}
                            </Space>

                            <Space size="small">
                                <Tag color={isLocked(telemetryStudent) ? 'red' : 'default'} icon={isLocked(telemetryStudent) ? <LockOutlined /> : undefined}>
                                    {isLocked(telemetryStudent) ? 'BLOQUEJAT' : 'ESTAT REGULAR'}
                                </Tag>
                            </Space>
                        </div>

                        {/* Tabs de telemetria */}
                        <Tabs
                            activeKey={activeTelemetryTabKey}
                            onChange={(k: any) => setActiveTelemetryTabKey(k)}
                            items={[
                                {
                                    key: 'timeline',
                                    label: <span><ClockCircleOutlined /> Línia de Temps</span>,
                                    children: (
                                        <>
                                            {/* Filtre per fitxer */}
                                            {Object.keys(availableTelemetryFiles).length > 0 && (
                                                <div style={{ marginBottom: 16, padding: '8px 12px', background: '#ffffff', borderRadius: 6, border: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                                                    <Space size="small">
                                                        <Text strong style={{ fontSize: 13 }}><FileOutlined /> Fitxer:</Text>
                                                        <Select
                                                            style={{ width: 300 }}
                                                            allowClear
                                                            placeholder="Tots els fitxers"
                                                            value={selectedFileFilter}
                                                            onChange={val => setSelectedFileFilter(val || null)}
                                                        >
                                                            {Object.entries(availableTelemetryFiles).map(([fname, info]) => (
                                                                <Select.Option key={fname} value={fname}>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                        <span>{fname}</span>
                                                                        <Space size={4}>
                                                                            {info.edits > 0 && <Tag color="purple" style={{ fontSize: 10, margin: 0 }}>{info.edits} edits</Tag>}
                                                                            <Tag style={{ fontSize: 10, margin: 0 }}>{info.count} regs</Tag>
                                                                        </Space>
                                                                    </div>
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Space>
                                                    <Text type="secondary" style={{ fontSize: 12 }}>
                                                        {Object.keys(availableTelemetryFiles).length} {Object.keys(availableTelemetryFiles).length === 1 ? 'fitxer detectat' : 'fitxers detectats'}
                                                    </Text>
                                                </div>
                                            )}

                                            {/* Línia temporal d'esdeveniments */}
                                            {telemetryLoading ? (
                                                <div style={{ textAlign: 'center', padding: 32 }}>Carregant historial de telemetria...</div>
                                            ) : groupedTelemetryItems.length === 0 ? (
                                                <Empty description={`Sense activitat registrada per al ${telemetryDate.format('DD/MM/YYYY')}`} style={{ padding: '24px 0' }} />
                                            ) : (
                                                <Timeline
                                                    style={{ maxHeight: 420, overflowY: 'auto', paddingTop: 8 }}
                                                    items={groupedTelemetryItems.map((item: any, idx: number) => {
                                                        const ev = item.representativeEvent;
                                                        const st = item.eventStatus;

                                                        const statusColor = st === 'activo' ? 'green' : st === 'conectado' ? 'blue' : 'gray';
                                                        const statusDot = st === 'activo'
                                                            ? <ThunderboltOutlined style={{ color: '#52c41a' }} />
                                                            : st === 'conectado'
                                                                ? <DesktopOutlined style={{ color: '#1890ff' }} />
                                                                : <MinusCircleTwoTone twoToneColor="#bbb" />;
                                                        const statusTag = st === 'activo'
                                                            ? <Tag color="green" icon={<ThunderboltOutlined />}>actiu</Tag>
                                                            : st === 'conectado'
                                                                ? <Tag color="blue" icon={<DesktopOutlined />}>connectat</Tag>
                                                                : <Tag>desconnectat</Tag>;

                                                        if (item.isGroup || (item.files && item.files.length > 1)) {
                                                            const groupLabel = st === 'activo'
                                                                ? 'actiu sense edicions' : st === 'conectado'
                                                                    ? 'connectat sense canvis' : 'desconnectat';
                                                            return {
                                                                key: `group-${idx}-${item.startTs}`,
                                                                color: statusColor,
                                                                dot: statusDot,
                                                                children: (
                                                                    <div style={{ padding: '4px 0' }}>
                                                                        <Space wrap>
                                                                            <Text strong>
                                                                                {formatDateTime(item.startTs)} — {formatDateTime(item.endTs)}
                                                                            </Text>
                                                                            <Tag color={statusColor}>
                                                                                {item.count} intervals {groupLabel}
                                                                            </Tag>
                                                                            {item.totalActiveSeconds > 0 && (
                                                                                <Tag>{formatDuration(item.totalActiveSeconds)} acumulats</Tag>
                                                                            )}
                                                                        </Space>
                                                                        {item.files && item.files.length > 0 && (
                                                                            <div style={{ fontSize: 12, color: '#888', marginTop: 4, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                                                                <FileOutlined style={{ marginRight: 4 }} />
                                                                                {item.files.map((f: string) => (
                                                                                    <Tag key={f} style={{ fontSize: 11, margin: 0 }}>{f}</Tag>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )
                                                            };
                                                        }

                                                        return {
                                                            key: `ev-${item.representativeEvent.id || idx}`,
                                                            color: statusColor,
                                                            dot: statusDot,
                                                            children: (
                                                                <div>
                                                                    <div>
                                                                        <Text strong>{formatDateTime(ev.event_ts)}</Text>{' '}
                                                                        {statusTag}
                                                                        {ev.edits > 0 && <Tag color="purple">{ev.edits} edicions</Tag>}
                                                                        {(ev.runs || 0) > 0 && <Tag color="cyan" icon={<PlayCircleOutlined />}>{ev.runs} run</Tag>}
                                                                        {(ev.debugs || 0) > 0 && <Tag color="magenta" icon={<BugOutlined />}>{ev.debugs} debug</Tag>}
                                                                        {ev.active_seconds > 0 && <Tag>{formatDuration(ev.active_seconds)}</Tag>}
                                                                    </div>
                                                                    <div style={{ fontSize: 12, color: '#666', marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                        <div>
                                                                            <FileOutlined /> {ev.file || '—'}
                                                                            {ev.language ? <Tag color="blue" style={{ marginLeft: 8 }}>{ev.language}</Tag> : null}
                                                                            {ev.project ? <Tag style={{ marginLeft: 4 }}>{ev.project}</Tag> : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        };
                                                    })}
                                                />
                                            )}
                                        </>
                                    )
                                },
                                {
                                    key: 'clipboard',
                                    label: (
                                        <span>
                                            <CopyOutlined /> Copiar / Pegar
                                            {telemetryClipboardEvents.length > 0 && (
                                                <Tag color="red" style={{ marginLeft: 6, fontSize: 11, borderRadius: 8, padding: '0 5px' }}>
                                                    {telemetryClipboardEvents.length}
                                                </Tag>
                                            )}
                                        </span>
                                    ),
                                    children: (
                                        <div style={{ maxHeight: 420, overflowY: 'auto', paddingTop: 8 }}>
                                            {telemetryClipboardEvents.length === 0 ? (
                                                <Empty description="No s'han detectat operacions de copiar ni pegar per a aquest alumne" />
                                            ) : (
                                                <Table
                                                    size="small"
                                                    dataSource={telemetryClipboardEvents}
                                                    rowKey={(row: any, idx) => row.id || `clip-${idx}`}
                                                    pagination={{ pageSize: 8 }}
                                                    columns={[
                                                        {
                                                            title: 'Acció',
                                                            dataIndex: 'action_type',
                                                            key: 'action_type',
                                                            width: 90,
                                                            render: (action: string) => {
                                                                const color = action === 'PASTE' ? 'orange' : action === 'COPY' ? 'blue' : action === 'CUT' ? 'volcano' : 'green';
                                                                return <Tag color={color} style={{ fontWeight: 'bold' }}>{action}</Tag>;
                                                            }
                                                        },
                                                        {
                                                            title: 'Origen',
                                                            dataIndex: 'source_element',
                                                            key: 'source_element',
                                                            width: 120,
                                                            render: (src: string) => <Tag color="geekblue">{src || 'EXAM_FRAME'}</Tag>
                                                        },
                                                        {
                                                            title: 'Data i hora',
                                                            dataIndex: 'event_ts',
                                                            key: 'event_ts',
                                                            width: 150,
                                                            render: (ts: string) => formatDateTime(ts)
                                                        },
                                                        {
                                                            title: 'Contingut Copiat/Pegat',
                                                            dataIndex: 'content_text',
                                                            key: 'content_text',
                                                            render: (txt: string) => (
                                                                <div style={{
                                                                    maxHeight: 70,
                                                                    maxWidth: 320,
                                                                    overflowY: 'auto',
                                                                    background: '#f5f5f5',
                                                                    padding: '4px 6px',
                                                                    borderRadius: 4,
                                                                    fontFamily: 'monospace',
                                                                    fontSize: 11,
                                                                    whiteSpace: 'pre-wrap',
                                                                    wordBreak: 'break-all'
                                                                }}>
                                                                    {txt || '(buit)'}
                                                                </div>
                                                            )
                                                        }
                                                    ]}
                                                />
                                            )}
                                        </div>
                                    )
                                },
                                {
                                    key: 'locks',
                                    label: (
                                        <span>
                                            <LockOutlined /> Bloquejos
                                            {telemetryLockEvents.filter((e: any) => e.action_type === 'LOCK').length > 0 && (
                                                <Tag color="red" style={{ marginLeft: 6, fontSize: 11, borderRadius: 8, padding: '0 5px' }}>
                                                    {telemetryLockEvents.filter((e: any) => e.action_type === 'LOCK').length}
                                                </Tag>
                                            )}
                                        </span>
                                    ),
                                    children: (
                                        <div style={{ maxHeight: 420, overflowY: 'auto', paddingTop: 8 }}>
                                            {telemetryLockEvents.length === 0 ? (
                                                <Empty description="No s'han registrat bloquejos per a aquest alumne" />
                                            ) : (
                                                <Table
                                                    size="small"
                                                    dataSource={telemetryLockEvents}
                                                    rowKey={(row: any, idx) => row.id || `lock-${idx}`}
                                                    pagination={{ pageSize: 8 }}
                                                    columns={[
                                                        {
                                                            title: 'Acció',
                                                            dataIndex: 'action_type',
                                                            key: 'action_type',
                                                            width: 110,
                                                            render: (action: string) => action === 'UNLOCK'
                                                                ? <Tag color="green" icon={<UnlockOutlined />} style={{ fontWeight: 'bold' }}>Desbloqueig</Tag>
                                                                : <Tag color="red" icon={<LockOutlined />} style={{ fontWeight: 'bold' }}>Bloqueig</Tag>
                                                        },
                                                        {
                                                            title: 'Motiu',
                                                            dataIndex: 'reason',
                                                            key: 'reason',
                                                            width: 140,
                                                            render: (reason: string) => reason
                                                                ? <Tag color={reason === 'FOCUS_LOST' ? 'volcano' : 'geekblue'}>{reason}</Tag>
                                                                : '-'
                                                        },
                                                        {
                                                            title: 'Data i hora',
                                                            dataIndex: 'event_ts',
                                                            key: 'event_ts',
                                                            width: 150,
                                                            render: (ts: string) => formatDateTime(ts)
                                                        },
                                                        {
                                                            title: 'Detall',
                                                            dataIndex: 'detail',
                                                            key: 'detail',
                                                            render: (txt: string, row: any) => (
                                                                <div>
                                                                    <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{txt || '-'}</div>
                                                                    {row.actor_nom && (
                                                                        <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
                                                                            Per: {row.actor_nom}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )
                                                        }
                                                    ]}
                                                />
                                            )}
                                        </div>
                                    )
                                }
                            ]}
                        />
                    </>
                )}
            </Modal>
        </>
    );

    if (isPage) {
        return (
            <div style={{ background: '#f8f9fb', minHeight: '100%', padding: '0 8px' }}>
                {mainContent}
                {extraModals}
            </div>
        );
    }

    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <TeamOutlined style={{ color: '#1890ff', fontSize: 20 }} />
                    <span style={{ fontWeight: 700, fontSize: 17 }}>
                        Seguiment d'Alumnes · {activitat?.nom || `Activitat ${activitat?.id}`}
                    </span>
                    {activitat?.is_examen === 1 && (
                        <Tag color="volcano" style={{ fontWeight: 600 }}>Examen</Tag>
                    )}
                </div>
            }
            open={visible}
            onCancel={onClose}
            width={1400}
            style={{ top: 20 }}
            footer={[
                <Button key="close" onClick={onClose} style={{ borderRadius: 6 }}>
                    Tancar
                </Button>
            ]}
            centered
            destroyOnClose
            bodyStyle={{ padding: '20px 28px', background: '#f8f9fb', maxHeight: '85vh', overflowY: 'auto' }}
        >
            {mainContent}
            {extraModals}
        </Modal>
    );
};

export default ActivitatAlumnesBbddModal;
